module.exports = __webpack_public_path__ + "img/information_w.f687587c.svg";